import { render } from "./ScreamButton.vue?vue&type=template&id=1332e09e"
import script from "./ScreamButton.vue?vue&type=script&lang=js"
export * from "./ScreamButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ScreamButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1332e09e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1332e09e', __exports__)) {
    api.reload('1332e09e', __exports__)
  }
  
  module.hot.accept("./ScreamButton.vue?vue&type=template&id=1332e09e", () => {
    api.rerender('1332e09e', render)
  })

}


export default __exports__